import { ChangeDetectorRef, Component, NgZone, OnInit, afterNextRender } from '@angular/core';
import { GoToTopAnimation } from './go-to-top.animation';

/**
 * Element that shows after the user scroll something to the botton. When the
 * user interacts backs to the top. This should be in the AppComponent.
 */
@Component({
  selector: 'app-go-to-top',
  templateUrl: './go-to-top.component.html',
  styleUrls: ['./go-to-top.component.scss'],
  animations: GoToTopAnimation
})
export class GoToTopComponent {
  /**
   * Show or hide the component.
   */
  display = false;

  /**
   * How much the user should scroll to see the element.
   */
  topPosToStartShowing = 750;

  /**
   * @deprecated Don`t found any use.
   */
  isBrowser = false;

  constructor(
    private zone: NgZone,
    private cd: ChangeDetectorRef
  ) {
    afterNextRender(() => {
      this.zone.runOutsideAngular(() => {
        let that = this;
        window.document.addEventListener('scroll', elem => {
          if (this.getYPosition(elem) >= that.topPosToStartShowing) {
            if (that.display == false) {
              that.display = true;
              this.cd.detectChanges();
            }
          } else {
            if (that.display == true) {
              that.display = false;
              this.cd.detectChanges();
            }
          }
        });
      });
    });
  }

  /**
   * Scolls to the top page.
   */
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  /**
   * Gets the scroll position from a event.
   *
   * //TODO barbeitoalex propostal - add the e type or remove this method.
   * @param e
   * @returns
   */
  getYPosition(e) {
    return e.target.scrollingElement.scrollTop;
  }
}
